import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl, baseimgUrl } from "../Univ";
import CompareBar from "./CompareBar";
import Recommended from "./Recommended";
import RecentlyViewed from "./RecentlyViewed";
import Filters from "./Filters";

import { Link, useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function ProductList() {

  const [products, setProducts] = useState([]);
  const [query, setQuery] = useState("");
  const [compare, setCompare] = useState([]);
  const [filterQuery, setFilterQuery] = useState("");

  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("userGroup") === "Customer";

  // -----------------------
  // FETCH PRODUCTS (PUBLIC)
  // -----------------------
  const fetchProducts = async () => {
    try {
      const res = await axios.get(baseUrl + "view-products/");
      setProducts(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // -----------------------
  // FETCH FILTERED PRODUCTS
  // -----------------------
  const fetchFilteredProducts = async (params = "") => {
    try {
      const url = baseUrl + "filter-products/?" + params;
      const res = await axios.get(url);
      setProducts(res.data);
    } catch (err) {
      console.error(err);
      setProducts([]);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {

    let params = "";

    if (filterQuery) params = filterQuery;
    if (query) params += (params ? "&" : "") + `search=${query}`;

    if (params) fetchFilteredProducts(params);
    else fetchProducts();

  }, [filterQuery, query]);

  // -----------------------
  // COMPARE
  // -----------------------
  const addCompare = (product) => {
    if (compare.length < 4 && !compare.some(p => p.id === product.id)) {
      setCompare([...compare, product]);
    }
  };

  // -----------------------
  // CART
  // -----------------------
  const addToCart = async (id) => {

    if (!isLoggedIn) {
      navigate("/user-login");
      return;
    }

    await axios.post(
      baseUrl + "add-cart/",
      { product_id: id },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      }
    );

    alert("Added to cart");
  };

  // -----------------------
  // WISHLIST
  // -----------------------
  const addWishlist = async (id) => {

    if (!isLoggedIn) {
      navigate("/user-login");
      return;
    }

    await axios.post(
      baseUrl + "add-wishlist/",
      { product_id: id },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      }
    );

    alert("Added to wishlist");
  };

  // -----------------------
  // RENDER
  // -----------------------
  return (
    <div className="container mt-4">

      {/* SEARCH */}
      <input
        className="form-control mb-3"
        placeholder="Search products..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      <Filters applyFilter={setFilterQuery} />

      {/* PRODUCT CAROUSEL */}
      <Carousel
        showArrows
        showThumbs={false}
        infiniteLoop
        autoPlay
        swipeable
        emulateTouch
      >

        {products.length > 0 ? (
          products.map((p) => (

            <div key={p.id}>
              <div className="card h-100">

                <Link to={`/product/${p.id}`}>
                  <img
                    src={`${p.images?.[0]?.image || "https://via.placeholder.com/180x150?text=No+Image"}`}
                    alt={p.name}
                    style={{ objectFit: "contain", maxHeight: "200px" }}
                  />
                </Link>

                <div className="card-body">

                  <h6>{p.name}</h6>

                  <p className="text-success fw-bold">
                    ₹{p.discount_price || p.price}{" "}
                    {p.discount_price && (
                      <span className="text-muted text-decoration-line-through">
                        ₹{p.price}
                      </span>
                    )}
                  </p>

                  <div className="d-flex gap-2 justify-content-center">

                    <button
                      className="icon-btn compare-btn"
                      onClick={() => addCompare(p)}
                    >
                      <i className="fa-solid fa-scale-balanced"></i>
                    </button>

                    <button
                      className="icon-btn cart-btn"
                      onClick={() => addToCart(p.id)}
                    >
                      <i className="fa-solid fa-cart-shopping"></i>
                    </button>

                    <button
                      className="icon-btn wish-btn"
                      onClick={() => addWishlist(p.id)}
                    >
                      <i className="fa-regular fa-heart"></i>
                    </button>

                  </div>

                </div>

              </div>
            </div>

          ))
        ) : (
          <div>
            <p>No products found</p>
          </div>
        )}

      </Carousel>

      {/* COMPARE BAR */}
      <CompareBar compare={compare} />
{isLoggedIn && (
  <>
    {/* RECOMMENDED */}
    <Recommended />

    {/* RECENTLY VIEWED */}
    <RecentlyViewed />
  </>
)}

    </div>
  );
}

export default ProductList;
